import { IListener, injectDataCache, injectSubject } from '@aesop-fables/scrinium';
import type { DataCache } from '@aesop-fables/scrinium';
import { Observable, Subscription, distinctUntilChanged } from 'rxjs';
import { Predicates } from '../../../predicates/Types';
import { InvoiceCompartments, invoiceStorageKey } from '..';

export class InvoicesListener implements IListener {
  private initialized = false;
  constructor(
    @injectSubject(Predicates.OrganizationSelected)
    private readonly predicate: Observable<boolean>,
    @injectDataCache(invoiceStorageKey)
    private readonly cache: DataCache<InvoiceCompartments>,
  ) {}

  start(): Subscription {
    return this.predicate.pipe(distinctUntilChanged()).subscribe(x => {
      if (this.initialized) {
        if (x) {
          this.cache.reload('invoices');
        } else {
          this.cache.reset('invoices');
        }
      } else if (x) {
        this.initialized = true;
      }
    });
  }
}
